
import React, { Component } from 'react'
import CreateTicketType from './CreateTicketType'
import ViewTicketType from './ViewTicketType'
import setTitle from "../../../helpers/TitleComponent";
import { getCookie, getAccessToken } from "../../../helpers/cookieHelper";
import { API_URL } from '../../../constants';
import { Messager } from 'rc-easyui';



const axios = require("axios");
export default class TicketType extends Component {
    constructor() {
        super()
        this.childRef = React.createRef()
        this.state = {
            Type: {
                projectId: "",
                ticketType: "",
            },
            ticketTypeList: [],
            projectList: [],
            rules: {
                projectId: ['required'],
                ticketType: ['required'],
            },
            operation: "Add",
            selected: {},
            permissions: [],

            isLoading: false,
            pageOptions: {
                pageOptions: {
                    layout: [
                        "list",
                        "sep",
                        "first",
                        "prev",
                        "next",
                        "last",
                        "sep",
                        "refresh",
                        "sep",
                        "manual",
                        "info",
                    ],
                },
            },
        }

    }
    componentDidMount = () => {
        var data = getCookie('permission');
        this.setState({
            permissions: JSON.parse(data),
            pageOptions: {
                loading: true,
                pageOptions: {
                  pageNumber: 1,
                  pageSize: 10,
                  total: 1000,
                  pagePosition: 'bottom',
                  pageList: [10, 20, 30, 40, 50, 60, 70, 80],
                  layout: [
                    'list',
                    'sep',
                    'first',
                    'prev',
                    'next',
                    'last',
                    'sep',
                    'refresh',
                    'sep',
                    'manual',
                    'info',
                  ],
                },
              },
        },


            function () {
                setTitle('Project Info. Entry')

                
                this.getProjectID()
            }
        );
    }



    handleInput = (name, value) => {

        const newArr = { ...this.state.Ticket }
        newArr[name] = value
        this.setState({
            student: newArr

        })

    }
    // formClear=()=> {
    //     let clearTicket = {
    //          priority:""
    //     };
    //     this.setState({
    //         prioirty: clearTicket,
    //         operation: "Add",
    //       },
    //       function () {
    //            this.childRef.current.validate((errors) => {});
    //                   }
    //               );
    //   }
    OnEditClick = (row) => {
        //  var rules = this.state.rules;
        //     console.log( this.state.selected);
        //     if (this.state.selected != null) {

        //       this.setState({
        //         rules: rules,
        //         priority: this.state.selected,
        //         operation: "Update",
        //       });

        //       const timer = setTimeout(() => {
        //         this.childRef.current.validate((errors) => {});
        //       }, 100);
        //       return () => clearTimeout(timer);
        //     }
        this.setState({
            Type: row,
            operation: 'update'
        })
    }
    onSelectionChange = (selectedRow) => {
        
        this.setState({
            selected: selectedRow,
        });
    }
    getProjectID = async () => {
        let erp_access_token = getCookie('access_token')
        let erp_token_type = getCookie('token_type')
        let headerConfig = {
            headers: {
                authorization: erp_token_type + ' ' + erp_access_token,
                'Content-Type': 'application/json',
            },
        }
        //   console.log(erp_access_token)
        if (erp_access_token != null) {
            this.setState({
                isLoading: true,
            })
            let url = API_URL + 'api/fetchallprojectInfo';
            axios.get(url, headerConfig)
                .then((response) => {

                    if (response.status === 200) {
                        var dataObject = response.data.object

                        this.setState({
                            projectList: dataObject
                        },()=>this.getPageData())

                    } else {
                        this.setState({
                            projectList: [],
                        })
                    }
                })
                .catch((error) => {
                    this.setState({
                        projectList: [],
                    })
                    // alert ("Internal server error");
                    let response = error['response']
                    if (response !== undefined) {
                        this.messager.alert({
                            title: 'Error',
                            icon: 'error',
                            reload: false,
                            msg: response.data.message
                        })//Backend Validation Error i.e. 403
                    } else {
                        this.messager.alert({
                            title: 'Error',
                            icon: 'error',
                            msg: 'Internal Server Error',
                            reload: false,
                        })// Caused due to syntax error in front end
                    }
                })
        } else {
            const resp = await getAccessToken()
            if (resp) {
                this.getProjectID()
            }
        }

    }

    getTicketTypeId = async () => {
        let erp_access_token = getCookie('access_token')
        let erp_token_type = getCookie('token_type')
        let headerConfig = {
            headers: {
                authorization: erp_token_type + ' ' + erp_access_token,
                'Content-Type': 'application/json',
            },
        }
        if (erp_access_token !== null) {
            axios.get(API_URL + 'api/fetchalltickettype', headerConfig)
                .then((response) => {
                    if (response.status === 200) {

                        let dataObject = response.data.object
                        this.setState({
                            ticketTypeList: dataObject
                        })
                    } else {
                        this.setState({
                            ticketTypeList: [],
                        })
                    }
                })
                .catch((error) => {
                    //console.log(error)
                    this.setState({
                        ticketTypeList: [],
                    })
                    //alert("Internal server error")l
                    let response = error['response']
                    if (response !== undefined) {
                        if (response.data.status === 403) {
                            this.messager.alert({
                                title: 'Error',
                                icon: 'error',
                                reload: false,
                                msg: response.data.message,
                            }) //Backend Validation Error i.e. 403
                        } else {
                            this.messager.alert({
                                title: 'Error',
                                msg: 'UnCaught Error',
                                icon: 'error',
                                reload: false,
                            })//uncaught Backend Error i.e. 500
                        }
                    } else {
                        this.messager.alert({
                            title: 'Error',
                            icon: 'error',
                            msg: 'Internal Server Error',
                            reload: false
                        })// caused due to syntax error in front end
                    }
                })
        } else {
            const resp = await getAccessToken()
            if (resp) {
                this.getTicketTypeId()
            }
        }
    }

    async getPageData() {
        let token = getCookie("access_token");
        let tokenType = getCookie("token_type");
        let apiUrl = `${API_URL}api/fetchalltickettype`;
        let headersConfig = {
          headers: {
            "Content-Type": "application/json",
            Authorization: `${tokenType} ${token}`,
          },
        };
        if (token != null) {
          axios
            .get(apiUrl, headersConfig)
            .then((response) => {
              //console.log("response data",response);
              let data = response.data.object;
              let arr=[]
              data.map(d=>{
                this.state.projectList.map(p=>{
                    if(p.id==d.projectId){
                       arr.push({
                        id:d.id,
                        projectId:d.projectId,
                        ticketType:d.ticketType,
                        projectName:p.projectName
                       })
                    }
                })
              })

              if (response.status === 200 && data.length > 0) {
                //console.log(data);
                this.setState({
                  ticketTypeList: arr,
                  pageOptions: {
                    pageOptions: { ...this.state.pageOptions.pageOptions },
                    loading: false,
                  },
                });
              } else {
                this.setState({
                  pageOptions: {
                    pageOptions: { ...this.state.pageOptions.pageOptions },
                    loading: false,
                  },
                });
              }
            })
            .catch((error) => {
              this.setState({
                pageOptions: {
                  pageOptions: {
                    ...this.state.pageOptions.pageOptions,
                  },
                  loading: false,
                },
              });
            });
        } else {
          const resp = await getAccessToken();
          if (resp) {
            this.getPageData();
          }
        }
      }

    onPageChange = (event) => {
        //delete event["refresh"];
        delete event["filterRules"];
        //console.log(event);
        this.setState(
          {
            pageOptions: {
              pageOptions: { ...this.state.pageOptions.pageOptions, ...event },
              loading: true,
            },
          },
          function () {
            this.getPageData();
          }
        );
      }

    render() {

        return (
            <div>
                <Messager ref={ref => this.messager = ref}></Messager>

                <div className='container-fluid'>
                    <div className='row'>
                        <div className='col-4'>


                            <CreateTicketType
                                Type={this.state.Type}
                                handleInput={this.handleInput}
                                operation={this.state.operation}
                                rules={this.state.rules}
                                ref={this.childRef}
                                formClear={this.formClear}
                                projectList={this.state.projectList}
                            />
                        </div>
                        <div className='col-8'>
                            <ViewTicketType

                                OnEditClick={this.OnEditClick}
                                onSelectionChange={this.onSelectionChange}
                                selectedRow={this.state.selected}

                                permissions={this.state.permissions}
                                ticketTypeList={this.state.ticketTypeList}
                                getTicketTypeId={this.getTicketTypeId}
                                pageOptions={this.state.pageOptions}
                                onPageChange={this.onPageChange}
                            />
                        </div>

                    </div>
                </div>

            </div>
        )
    }
}
